// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const SimpleNav = require('client-v2/common/components/simple-nav')
// Entry container imports
const {
  navigateToSearchCollections,
  navigateToSearchInterests,
  navigateToSearchPeople,
  navigateToSearchPosts,
  searchCollectionsHref,
  searchInterestsHref,
  searchPeopleHref,
  searchPostsHref
} = require('../query/actions')

const bemEntity = BemEntity('SearchNav')

function mapStateToProps() {
  const itemsSelector = createItemsSelector()
  return function (state) {
    return {
      bemEntity,
      itemsSelector,
      selectedItemId: selectedState(state),
      query: state.query
    }
  }
}

const mapDispatchToProps = {
  onCollectionsClick: navigateToSearchCollections,
  onInterestsClick: navigateToSearchInterests,
  onPeopleClick: navigateToSearchPeople,
  onPostsClick: navigateToSearchPosts
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    items: stateProps.itemsSelector(stateProps, dispatchProps)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(
  withImmutableToJS(
    SimpleNav
  )
)

// State helpers

function createItemsSelector() {
  return createSelector(
    [
      (stateProps) => stateProps.query.decoded,
      (stateProps, dispatchProps) => dispatchProps
    ],
    (query, dispatchProps) => [
      {
        id: 'posts',
        label: `Posts`,
        href: searchPostsHref(query),
        onClick: event => dispatchProps.onPostsClick({ event, query })
      },
      {
        id: 'collections',
        label: `Collections`,
        href: searchCollectionsHref(query),
        onClick: event => dispatchProps.onCollectionsClick({ event, query })
      },
      {
        id: 'people',
        label: `People`,
        href: searchPeopleHref(query),
        onClick: event => dispatchProps.onPeopleClick({ event, query })
      },
      {
        id: 'interests',
        label: `Interests`,
        href: searchInterestsHref(query),
        onClick: event => dispatchProps.onInterestsClick({ event, query })
      }
    ]
  )
}

function selectedState(state) {
  switch (state.router.action) {
    case 'search.showDomainPosts':
      return 'domain'
    case 'search.showQueryCollections':
      return 'collections'
    case 'search.showQueryInterests':
      return 'interests'
    case 'search.showQueryPeople':
      return 'people'
    case 'search.showQueryPosts':
      return 'posts'
    default:
      return null
  }
}
